class NSSRecommendations extends HTMLElement {

    constructor() {
        super();
        this.debug = false;
    }

    connectedCallback() {
        if (this.debug) console.log("[NSS][Recommendations] Connected.");
        this.initRecommendations();
    }

    initRecommendations() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            const url = this.dataset.url;
            fetch(url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('nss-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        };

        const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 0px 0px' });
        observer.observe(this);
    }
}

let elementName = `nss-recommendations`;
if (typeof customElements.get(elementName) === `undefined`) {
    customElements.define(elementName, NSSRecommendations);
} else {
    console.warn(`[NSS] Element '${elementName}' already defined.`);
}
